import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9eac6a1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section"
}
const _hoisted_2 = { class: "section__header" }
const _hoisted_3 = { class: "section__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "›", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "section__scroll" }
const _hoisted_8 = { class: "section__track" }
const _hoisted_9 = { class: "groupon-card__cover" }
const _hoisted_10 = { class: "groupon-card__title" }
const _hoisted_11 = { class: "groupon-card__date" }

import { computed } from "vue";
import { Image as VanImage } from "vant";
import { formatHotspotGrouponDate } from "../model";
import type { HotspotGrouponSection } from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouponCarousel',
  props: {
    section: null
  },
  emits: ["open-app"],
  setup(__props: any, { emit }: { emit: ({
  (event: "open-app"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  section: HotspotGrouponSection;
}





const sectionTitle = computed(() => {
  const count = props.section?.count;
  return [props.section?.title, count === undefined ? "" : String(count)]
    .filter(Boolean)
    .join(" ");
});

return (_ctx: any,_cache: any) => {
  return (__props.section?.list?.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(sectionTitle)), 1),
          _createElementVNode("div", {
            class: "section__action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open-app')))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.list, (item, index) => {
              return (_openBlock(), _createElementBlock("article", {
                key: item.groupon?.id || index,
                class: "groupon-card",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('open-app')))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (item.groupon?.coverImages?.[0])
                    ? (_openBlock(), _createBlock(_unref(VanImage), {
                        key: 0,
                        fit: "cover",
                        class: "groupon-card__cover-image",
                        src: item.groupon?.coverImages?.[0],
                        alt: item.groupon?.title || ''
                      }, null, 8, ["src", "alt"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.groupon?.title), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(formatHotspotGrouponDate)(item.groupon?.eventStartedTime)), 1)
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})